import envConfig from '../../static/config';

const getManageCredentialsLink = (isSMEUser) =>
  isSMEUser
    ? envConfig.manageCredentialLinkSME
    : envConfig.manageCredentialLink;

export { getManageCredentialsLink };
